import {useContext} from 'react';
import {FabricContext} from '~/common/fabric/context/FabricContext';
import {Button} from '~library/atoms/Button';

export const DoneButton = ({handleDoneClick}) => {
  const {canvas} = useContext(FabricContext);

  const discardSelection = () => {
    handleDoneClick();
    canvas?.discardActiveObject()?.requestRenderAll();
  };

  return (
    <Button
      className="uyo-control-btn--done"
      variant="secondary"
      onClick={discardSelection}
      data-qa-id="uyo-control-done-btn"
      fullWidth
      size="large"
    >
      Done
    </Button>
  );
};
